var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgProtocolIcon = function SvgProtocolIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H1V4h11V1.5L15.5 5 12 8.5zm-8 4h11v2H4v2.5L.5 11 4 7.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProtocolIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;